export default __webpack_public_path__ + "12cb97611f773ac08a34705d9ac77e2b.png";